import { apiClient } from '../client'

type LogoutResponse = {
  message: string
}

/**
 * The backend needs to set cookie to null in browser since it has authority over the cookie's domain.
 */
export const logout = async (): Promise<LogoutResponse> =>
  apiClient.post('auth/logout').json<LogoutResponse>()
